<template>
  <div class="mgr-users">

      <el-card class="box-card" shadow="never">
        <div slot="header" class="card-header">
          <span>用户列表</span>
          <div class="card-header-actions">
            <span class="me">当前登录：{{ me.username || '-' }}</span>
            <el-button size="small" :loading="loading" @click="loadUsers">刷 新</el-button>
            <el-button size="small" type="primary" @click="addVisible = true">添加用户</el-button>
          </div>
        </div>

        <!-- el-table 在当前 Vue 2.7 栈上不渲染行（store 有数据 DOM 为空），改用原生表格，与 bijimng/travelmng 一致 -->
        <div class="mu-table-wrap" v-loading="loading">
          <table class="mu-table">
            <thead>
              <tr>
                <th>用户名</th>
                <th>角色</th>
                <th>创建时间</th>
                <th class="mu-op">操作</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="row in users" :key="row.username">
                <td data-label="用户名">{{ row.username }}</td>
                <td data-label="角色">
                  <span class="mu-role" :class="row.role === 'admin' ? 'mu-role--admin' : 'mu-role--user'">
                    {{ row.role === 'admin' ? '管理员' : '用户' }}
                  </span>
                </td>
                <td data-label="创建时间">{{ formatTime(row.createTime) }}</td>
                <td data-label="操作" class="mu-op">
                  <el-button
                    size="mini"
                    type="primary"
                    plain
                    @click="openPasswordDialog(row)"
                  >
                    修改密码
                  </el-button>
                  <el-button
                    v-if="row.role !== 'admin'"
                    size="mini"
                    type="danger"
                    plain
                    @click="deleteUser(row)"
                  >
                    删除
                  </el-button>
                </td>
              </tr>
              <tr v-if="!loading && users.length === 0">
                <td colspan="4" class="mu-empty">暂无用户数据</td>
              </tr>
            </tbody>
          </table>
        </div>
      </el-card>

      <!-- 添加用户 -->
      <el-dialog title="添加用户" :visible.sync="addVisible" width="420px" @closed="resetCreateForm">
        <el-form label-width="80px" @submit.native.prevent>
          <el-form-item label="用户名">
            <el-input v-model="createForm.username" placeholder="请输入用户名" autocomplete="off" />
          </el-form-item>
          <el-form-item label="密码">
            <el-input
              v-model="createForm.password"
              type="password"
              show-password
              autocomplete="off"
              placeholder="请输入密码"
            />
          </el-form-item>
          <el-form-item label="角色">
            <el-select v-model="createForm.role" style="width: 100%">
              <el-option label="用户" value="user" />
              <el-option label="管理员" value="admin" />
            </el-select>
          </el-form-item>
        </el-form>
        <div slot="footer">
          <el-button @click="addVisible = false">取 消</el-button>
          <el-button type="primary" :loading="submitting" @click="createUser">创 建</el-button>
        </div>
      </el-dialog>

      <!-- 修改密码：改自己需要原密码，重置他人不需要 -->
      <manager-password-dialog
        :visible.sync="pwdVisible"
        :username="pwdTarget"
        :require-old="pwdTarget === me.username"
      />
    </div>
</template>

<script>
import axios from 'axios'
import { UseUrl } from '../../utils/config'
import ManagerPasswordDialog from './ManagerPasswordDialog.vue'

export default {
  name: 'ManagerUsers',
  components: {
    ManagerPasswordDialog
  },
  data() {
    return {
      users: [],
      loading: false,
      submitting: false,
      me: {
        username: '',
        role: ''
      },
      addVisible: false,
      createForm: {
        username: '',
        password: '',
        role: 'user'
      },
      pwdVisible: false,
      pwdTarget: ''
    }
  },
  mounted() {
    this.loadMe()
    this.loadUsers()
  },
  methods: {
    async loadMe() {
      try {
        const res = await axios.post(UseUrl + '/manager/auth/me', {})
        if (res.data?.loggedIn) {
          this.me = res.data?.user || {}
        }
      } catch (e) {
        console.error('获取用户信息失败', e)
      }
    },
    async loadUsers() {
      this.loading = true
      try {
        const res = await axios.post(UseUrl + '/manager/user/list', {})
        this.users = res.data?.list || []
      } catch (e) {
        this.$message.error('获取用户列表失败')
      } finally {
        this.loading = false
      }
    },
    resetCreateForm() {
      this.createForm = { username: '', password: '', role: 'user' }
      this.submitting = false
    },
    async createUser() {
      if (this.submitting) return
      if (!this.createForm.username || !this.createForm.password) {
        this.$message.warning('请填写用户名和密码')
        return
      }
      this.submitting = true
      try {
        const res = await axios.post(UseUrl + '/manager/user/create', this.createForm)
        if (res.data?.success) {
          this.$message.success('创建成功')
          this.addVisible = false
          this.loadUsers()
        } else {
          this.$message.error(res.data?.message || '创建失败')
        }
      } catch (e) {
        this.$message.error('创建失败')
      } finally {
        this.submitting = false
      }
    },
    deleteUser(user) {
      this.$confirm(`确定要删除用户 "${user.username}" 吗？`, '删除确认', {
        confirmButtonText: '删 除',
        cancelButtonText: '取 消',
        type: 'warning'
      })
        .then(async () => {
          try {
            const res = await axios.post(UseUrl + '/manager/user/delete', { username: user.username })
            if (res.data?.success) {
              this.$message.success('删除成功')
              this.loadUsers()
            } else {
              this.$message.error(res.data?.message || '删除失败')
            }
          } catch (e) {
            this.$message.error('删除失败')
          }
        })
        .catch(() => {})
    },
    openPasswordDialog(user) {
      this.pwdTarget = user.username || ''
      this.pwdVisible = true
    },
    formatTime(timestamp) {
      if (!timestamp) return '-'
      const date = new Date(timestamp * 1000)
      return date.toLocaleString('zh-CN')
    }
  }
}
</script>

<style scoped>
.mgr-users {
  max-width: 960px;
  margin: 0 auto;
}

.card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 10px;
  font-weight: 600;
}

.card-header-actions {
  display: flex;
  align-items: center;
  gap: 12px;
  font-weight: 400;
}

.me {
  font-size: 13px;
  color: #909399;
}

/* 用户表格（原生 table） */
.mu-table-wrap {
  overflow-x: auto;
}

.mu-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
}

.mu-table th {
  padding: 10px 12px;
  background: #f5f7fa;
  color: #5a6474;
  font-weight: 600;
  text-align: left;
  white-space: nowrap;
  border-bottom: 1px solid #ebeef5;
}

.mu-table td {
  padding: 10px 12px;
  border-bottom: 1px solid #ebeef5;
  vertical-align: middle;
}

.mu-table tbody tr:hover {
  background: #f5f7fa;
}

.mu-op {
  white-space: nowrap;
}

.mu-empty {
  padding: 26px 0;
  text-align: center;
  color: #909399;
}

.mu-role {
  display: inline-block;
  padding: 2px 10px;
  border-radius: 10px;
  font-size: 12px;
  line-height: 18px;
}

.mu-role--admin {
  color: #fff;
  background: #f56c6c;
}

.mu-role--user {
  color: #606266;
  background: #e9e9ec;
}

@media (max-width: 600px) {
  .card-header-actions {
    width: 100%;
    justify-content: space-between;
  }
}
</style>
